import React from 'react';
import {AuthProvider} from './Auth/AuthContext';
import CreaPeriodo from './components/cierres/creaPeriodo';


function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CreaPeriodo />
      </AuthProvider>
    </div>
  );
}

export default App;

